import React from "react";

import { readOnlyValue } from "../../../../../attributes/lib/attribute-data";

const Footnotes = (props) => {
    const footnotes = props.data.items.map((footnote, index) => {
        return (
            <div
                key={`${index}_${props.data.length}`}
                className="footnote"
            >
                <div className="input-group">
                    <b>{readOnlyValue(footnote.noteMark, "DropdownPickList")}</b>
                    {footnote.text}
                </div>
            </div>
        );
    });

    return (
        <div className="footnotes">
            {props.isCodingQA ? <h4>Footnotes:</h4> : <h3>Footnotes</h3>}
            {footnotes}
        </div>
    );
};

export default Footnotes;
